import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { QueryParams } from '../../shared/models/query/queryParams.model';
import { HistoriqueBilat } from '../models/historique-bilat/historique-bilat.models';

@Injectable({
  providedIn: 'root',
})
export class QueryService {
  constructor(private http: HttpClient) {}

  getHistoriqueBilat(id_user: number, type: string, queryParams: QueryParams.QueryParamsPagination) {
    return this.http.get<[HistoriqueBilat.Get[], number]>(
      `${environment.apiUrl}/bilat/historique-bilat/${id_user}/${type}?nbr_items_per_page=${queryParams.nbr_items_per_page}&current_page=${queryParams.current_page}`,
      { observe: 'response' },
    );
  }

  getDetailBilat(id_bilat: number) {
    return this.http.get<HistoriqueBilat.GetDetailBilat>(`${environment.apiUrl}/bilat/rapport-bilat/${id_bilat}`, { observe: 'response' });
  }
  getCustomerBilat(id_bilat: number) {
    return this.http.get<[HistoriqueBilat.CustomerBilat[], number]>(`${environment.apiUrl}/bilat/customer-bilat/${id_bilat}`, {
      observe: 'response',
    });
  }

  setComment(id_bilat: number, comment: string) {
    return this.http.patch(`${environment.apiUrl}/bilat/comment/${id_bilat}`, comment, { observe: 'response' });
  }
}
